import { render, staticRenderFns } from "./Diversos.vue?vue&type=template&id=87767528&scoped=true&"
import script from "./Diversos.vue?vue&type=script&lang=js&"
export * from "./Diversos.vue?vue&type=script&lang=js&"
import style0 from "./Diversos.vue?vue&type=style&index=0&id=87767528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87767528",
  null
  
)

export default component.exports